export const dictionariesTags = {
  DICTIONARY: 'DICTIONARY',
  DICTIONARIES: 'DICTIONARIES',
  MEDICINE_RECORD: 'medicineRecord',
};
